<template>
  <div>
    <v-radio-group
      v-model="internalVal"
      class="pl-3 pr-3 mt-0"
      :rules="rules"
      :error-messages="errorMessages"
      :hide-details="hideDetails"
      @change="updateValue"
    >
      <template v-if="isHorizontal">
        <!-- <v-row justify="start">
          <v-col
            v-for="(radioItemConfig, index) in items"
            :key="index"
          >
            <v-radio
              :label="radioItemConfig.label"
              :value="radioItemConfig.itemValue"
            ></v-radio>
          </v-col>
        </v-row> -->

        <vue-horizontal
          scroll
          :button="false"
          class="horizontal"
        >
          <section
            v-for="(radioItemConfig, index) in items"
            :key="index"
          >
            <v-radio
              :label="radioItemConfig.label"
              :value="radioItemConfig.itemValue"
              @click="handleClick(radioItemConfig.itemValue)"
            ></v-radio>
          </section>
        </vue-horizontal>
      </template>
      <template v-else>
        <v-radio
          v-for="(radioItemConfig, index) in items"
          :key="index"
          :label="radioItemConfig.label"
          :value="radioItemConfig.itemValue"
          @click="handleClick(radioItemConfig.itemValue)"
        ></v-radio>
      </template>
    </v-radio-group>
    <v-row

      v-if="extraInput.enabled"
    >
      <v-col
        cols="12"
        md="6"
      >
        <v-text-field
          v-model="customInputValue"
          class="mb-2"
          outlined
          hide-details
          :label="extraInput.label"
          :type="extraInput.inputType"
          @input="handleCustomInput"
        >
        </v-text-field>
      </v-col>
    </v-row>
  </div>
</template>
<script setup>
import { ref, onMounted, computed, toRefs, watch } from 'vue'
import VueHorizontal from 'vue-horizontal'
import { useStore } from '@/store'

const props = defineProps({
  value: {
  },
  config: {
    type: Object,
    required: true,
  },

  // extraInput: {
  //   type: Object,
  //   defaultValue() {
  //     return {
  //       enabled: false,
  //       label: 'Custom Input',
  //     }
  //   },
  // },
})
const customInputValue = ref('')
const internalVal = ref({})
const internalPreVal = ref({})
const store = useStore()
const { config, value, hasExtraInput } = toRefs(props)
console.log(value)
if (value.value) {
  internalVal.value = value.value
}

watch(value, (newValue, preValue) => {
  internalVal.value = newValue
})
watch(internalVal, (newValue, preValue) => {
  internalVal.value = newValue
  internalPreVal.value = preValue
})

watch(internalVal, (newVal, preVale) => {
  if (newVal === preVale) {
    console.log('click selected')
  } else {
    console.log('click other')
  }
})

const isHorizontal = ref(config.value.type.isHorizontal)

const hideDetails = computed(() => {
  if (config.value.type.hideDetails) {
    return config.value.type.hideDetails
  }

  return false
})

const items = computed(() => {
  if (config.value.type.storeName) {
    console.log('this.storeName', config.value.type.storeName)

    return store.getters[config.value.type.storeName]
  }

  return config.value.type.groupItems || []
})

const rules = computed(() => {
  if (config.value.type.rules) {
    return config.value.type.rules
  }

  return []
})
const errorMessages = computed(() => {
  if (config.value.type.errorMessages) {
    return config.value.type.errorMessages
  }

  return []
})

const extraInput = computed(() => {
  if (config.value.type.extraInput) {
    return config.value.type.extraInput
  }

  return {
    enabled: false,
    label: 'Custom Input',
  }
})

const emit = defineEmits(['input'])
const updateValue = newValue => {
  emit('input', newValue)
  console.log('newValue', newValue)
}

function handleCustomInput() {
  internalVal.value = null
  updateValue(parseInt(customInputValue.value, 10))
}

onMounted(() => {
  if (typeof config.value.defaultValue !== 'undefined') {
    console.log('radioGroup defaultValue', config.value.defaultValue)
    updateValue(config.value.defaultValue)
  }
})
function handleClick(val) {
  console.log('handle click', val, internalVal.value)
  if (val === internalVal.value) {
    console.log('click selected')
  } else {
    console.log('click other')
  }
}
</script>
<style scoped>

.horizontal >>> .v-hl-container {
  /* Space between content and scrollbar */
  /* padding-bottom: 16px; */

  /* For firefox only */
  scrollbar-width: thin;
  /* scrollbar-color: orangered black; */
}

.horizontal >>> .v-hl-container::-webkit-scrollbar {
  height: 0px;
  width: 16px;
  background: transparent;
}
.horizontal .v-input--selection-controls__input{
  display: none;
}
</style>
<style>

.horizontal .v-radio .v-input--selection-controls__input{
  display: none;
}

.horizontal .v-radio,v-checkbox{
  margin-right: 10px;
  border-radius: 5px;
  border-style: solid;
  border-color: rgba(86, 98, 105, 0.1);
}
.horizontal .v-label{
  padding: 5px 10px;
  /* background-color: rgba(244, 247, 254,0.9); */
  border-radius: 5px;
}
.horizontal .v-item--active{

  border-radius: 5px;
  border-style: solid;
  border-color: #566369;
}
</style>
